import { render, staticRenderFns } from "./DialogVerPagoInscripcion.vue?vue&type=template&id=755d40d6&scoped=true"
import script from "./DialogVerPagoInscripcion.vue?vue&type=script&lang=js"
export * from "./DialogVerPagoInscripcion.vue?vue&type=script&lang=js"
import style0 from "./DialogVerPagoInscripcion.vue?vue&type=style&index=0&id=755d40d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755d40d6",
  null
  
)

export default component.exports